var _sodipodiNamedview, _defs, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfbmangenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200mm",
    height: "200mm",
    viewBox: "0 0 200 200",
    id: "svg7938",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "rfbmangen.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title30000"
  }, "RFB ManGen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title30000"
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7940",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDocumentUnits: "mm",
    showgrid: "false",
    inkscapeZoom: 1,
    inkscapeCx: 378,
    inkscapeCy: 379.5,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1005,
    inkscapeWindowX: -9,
    inkscapeWindowY: -9,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7935"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g29560",
    transform: "translate(5.2113056,34.027864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g29525"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007c59",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-8-09",
    width: 10,
    height: 10,
    x: 164.7887,
    y: 65.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#009f72",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-9",
    width: 10,
    height: 10,
    x: 144.7887,
    y: 35.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#009f72",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-8",
    width: 10,
    height: 10,
    x: 154.7887,
    y: 45.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#009f72",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-7",
    width: 10,
    height: 10,
    x: 164.7887,
    y: 55.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#004d37",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-71",
    width: 10,
    height: 10,
    x: 134.7887,
    y: 95.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#004d37",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-1",
    width: 10,
    height: 10,
    x: 144.7887,
    y: 85.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#004d37",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-3",
    width: 10,
    height: 10,
    x: 154.7887,
    y: 75.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#009f72",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2-2",
    width: 10,
    height: 10,
    x: 134.7887,
    y: 25.972136
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29533"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007c59",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28",
    width: 10,
    height: 10,
    x: 74.788696,
    y: 75.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007c59",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-4",
    width: 10,
    height: 10,
    x: 64.788696,
    y: 85.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007b18",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-5",
    width: 10,
    height: 10,
    x: 94.788696,
    y: 55.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007c59",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-4-0",
    width: 10,
    height: 10,
    x: 84.788696,
    y: 65.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007b18",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-28-2",
    width: 10,
    height: 10,
    x: 114.7887,
    y: 35.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#007b18",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-4-9",
    width: 10,
    height: 10,
    x: 104.7887,
    y: 45.972137
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29515"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#64e3d4",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055",
    width: 10,
    height: 10,
    x: 44.788692,
    y: 25.972139
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#09c7b3",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-9",
    width: 10,
    height: 10,
    x: 34.788692,
    y: 35.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#09c7b3",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-8",
    width: 10,
    height: 10,
    x: 24.788692,
    y: 45.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#02b5a3",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-8-0",
    width: 10,
    height: 10,
    x: 14.788692,
    y: 65.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#09c7b3",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-7",
    width: 10,
    height: 10,
    x: 14.788692,
    y: 55.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#006448",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-14",
    width: 10,
    height: 10,
    x: 44.788692,
    y: 95.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f9184",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-1",
    width: 10,
    height: 10,
    x: 34.788692,
    y: 85.972137
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1f9184",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    id: "rect8055-2",
    width: 10,
    height: 10,
    x: 24.788692,
    y: 75.972137
  })))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata29998"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcTitle", null, "RFB ManGen"), /*#__PURE__*/React.createElement("dcDate", null, "1/25/2024"), /*#__PURE__*/React.createElement("dcCreator", null, /*#__PURE__*/React.createElement("ccAgent", null, /*#__PURE__*/React.createElement("dcTitle", null, "Arturo Rabino"))), /*#__PURE__*/React.createElement("dcPublisher", null, /*#__PURE__*/React.createElement("ccAgent", null, /*#__PURE__*/React.createElement("dcTitle", null, "RareFrostbites Team"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfbmangenLogo);
export default __webpack_public_path__ + "static/media/rfbmangen_logo.6f460925742c121807dc311b3c9c9514.svg";
export { ForwardRef as ReactComponent };